export default __webpack_public_path__ + "static/0179-f4e2b2d42f822632e811e4f7c0af8232.png";